import HubSpotForm from "components/hubspot/form"
import { loadTemplate } from "utils/load_template"

class HubSpotContactForm extends HubSpotForm {
  onFormSubmitted(target) {
    const message = document.querySelector(`${target} .submitted-message p`)
    const template = loadTemplate("contact_form_icon_template")
    message.insertAdjacentHTML("beforebegin", template)
  }
}

export default HubSpotContactForm
